import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import React, { useEffect, useRef } from "react";
import { useContextProducto } from "../../../../contexto/producto/ProductoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";

const TablaBuscarProducto = ({ datos }) => {
  const { token } = useContextUsuario();
  const { setListaProductos, ActualizarLista } = useContextEmpleado();
  const tableRef = useRef();

  useEffect(() => {
    if (datos.length > 0) {
      const requiredFields = ['id', 'nombre', 'codigo', 'descripcion', 'precio', 'costo', 'existencia', 'impuesto', 'estado'];
      const missingFields = requiredFields.filter(field => !datos[0].hasOwnProperty(field));
      if (missingFields.length > 0) {
        console.error(`Los datos no contienen las propiedades necesarias: ${missingFields.join(', ')}`);
        return;
      }
    }

    $(tableRef.current).DataTable({
      data: datos,
      columns: [
        { targets: 1, title: "Id", data: "id" },
        {
          targets: 2,
          title: "Producto",
          data: null,
          render: (data, type, row) => {
            return `
                            <div>
                                <strong>${row.nombre}</strong><br/>
                                <small class="text-muted">Código: ${row.codigo || ""}</small>
                            </div>
                        `;
          }
        },
        { targets: 3, title: "Precio", data: "precio" },
        { targets: 4, title: "Costo", data: "costo" },
        { targets: 5, title: "Existencia", data: "existencia" },
        { targets: 6, title: "Impuesto", data: "impuesto" },
        {
          targets: 7,
          title: "Estado",
          data: "estado",
          render: (data) => {
            return `<span class="badge ${data === "Disponible" ? "badge-success" : "badge-danger"}">${data}</span>`;
          }
        },
        {
          targets: 9,
          title: "Tipo",
          data: "tipo",
          render: (data) => {
            return `<span class="badge ${data === "General" ? "badge-primary" : "badge-warning"}">${data}</span>`;
          }
        }
      ],
      paging: true,
      lengthChange: true,
      ordering: true,
      info: true,
      autoWidth: true,
      responsive: true,
      dom:
        "<'row mb-3'<'col-sm-12 col-md-6 text-left'l><'col-sm-12 col-md-6 text-right'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      language: {
        decimal: "",
        emptyTable: "No hay información",
        info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
        infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
        infoFiltered: "(Filtrado de _MAX_ total entradas)",
        lengthMenu: "Mostrar _MENU_ Entradas",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "Sin resultados encontrados",
        paginate: { first: "|<<", last: ">>|", next: ">>", previous: "<<" },
      },
      destroy: true,
    });
  }, [datos]);

  return (
    <div className="table-responsive">
      <table
        ref={tableRef}
        id="productos"
        className="table table-bordered table-hover nowrap"
        style={{ width: "100%" }}
      ></table>
    </div>
  );
};

export default TablaBuscarProducto;